import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Respect an explicit Authorization header (e.g. PG admin bearer) — only fall
  // back to the regular customer/admin JWT if none was set by the caller.
  if (config.headers && config.headers.Authorization) return config;
  const token = localStorage.getItem("optivize_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // optional: redirect to login
    }
    return Promise.reject(err);
  }
);

export const setToken = (token) => {
  if (token) localStorage.setItem("optivize_token", token);
  else localStorage.removeItem("optivize_token");
};

export const setUser = (u) => {
  if (u) localStorage.setItem("optivize_user", JSON.stringify(u));
  else localStorage.removeItem("optivize_user");
};

export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("optivize_user") || "null"); }
  catch { return null; }
};

export const logout = () => {
  setToken(null);
  setUser(null);
  window.location.href = "/";
};
